module.exports = __webpack_public_path__ + "img/Logo-29.321936b6.svg";